@if (firstLoading() && mode() === VIEW_MODE) {
  <lib-overlay-loader></lib-overlay-loader>
} @else {
  <div class="h-full">
    <lib-request-details-header
      [requestDetailsResponse]="workflowDetails()"
      [showRequestId]="showID()"
      [showTrigger]="false"
      [showCategory]="showCategory()"
      [showDescription]="showDescription()"
      [showStatus]="false" />

    <lib-tabs [tabPill]="true" [tabsClass]="'pb-2xl'">
      <lib-tab
        [tabTitle]="
          'workflow_permission_details_screen_all_resources_label' | transloco
        "
        [showTabTag]="true"
        [tabTag]="totalMembersCount()">
        <div class="flex flex-col justify-between h-full">
          <div>
            @if (mode() === VIEW_MODE) {
              <div
                class="flex justify-between items-center mb-lg border-b border-neutral-200">
                <div class="flex py-lg items-center">
                  <span class="text-lg font-semibold text-neutral-900 pe-lg">
                    {{
                      'workflow_permission_details_screen_all_resources_label'
                        | transloco
                    }}
                  </span>
                  <lib-badge
                    [label]="totalMembersCount()"
                    [badgeClass]="
                      'px-sm border-none text-sm font-medium bg-primary-50 text-primary-700'
                    " />
                </div>

                <a
                  [routerLink]="[
                    '/workflow/permissions/permission-details'
                      | tenantPath: 'admin',
                    workflowId,
                    'add',
                  ]"
                  class="bg-primary-500 text-white font-medium text-sm py-sm px-2xl border-none rounded-md gap-sm flex items-center"
                  id="workflow_permission_details_screen_add_resources_button_label">
                  <lib-add-icon [iconClass]="'size-5 text-white'" />

                  {{
                    'workflow_permission_details_screen_add_resources_button_label'
                      | transloco
                  }}
                </a>
              </div>
            }

            @if (mode() === VIEW_MODE) {
              <lib-workflow-details-table-view
                [tableData]="tableData()"
                [workflowId]="workflowId"
                [isLoading]="isLoading()"
                (memberEmitter)="handleMemberEmit($event)"
                [currentPage]="currentPage()"
                [currentSize]="currentSize()"></lib-workflow-details-table-view>
            } @else {
              <lib-workflow-details-table-add-member
                [flowTemplateCategoryId]="flowTemplateCategoryId()" />
            }
          </div>

          @if (mode() === VIEW_MODE && tableData().length) {
            <div class="p-sm">
              <lib-paginator
                class="mt-4xl"
                [sizeOptionsLabel]="
                  'pagination_number_of_rows_per_page_label' | transloco
                "
                [nextBtnLabel]="'pagination_next_button_label' | transloco"
                [previousBtnLabel]="
                  'pagination_previous_button_label' | transloco
                "
                [currentPage]="currentPage()"
                [totalPages]="totalPages()"
                [totalItems]="+totalMembersCount()"
                [showChangeSize]="true"
                [sizeOptions]="pageSizeOptions"
                (goTo)="handlePagination($event)"
                (next)="handlePagination($event)"
                (previous)="handlePagination($event)"
                (handleChangeSize)="changeSize($event)"
                [currentSize]="currentSize()"></lib-paginator>
            </div>
          }
        </div>
      </lib-tab>

      <lib-tab
        [tabTitle]="
          'workflow_permission_details_assignee_list_screen_tab_title'
            | transloco
        "
        [showTabTag]="true"
        [tabTag]="assigneeTotalCount()"
        #tab_2
        ><lib-workflow-details-assignee-table-view
          [tableData]="assigneeTableData()"
          [isLoading]="isAssigneeLoading()"
          [totalAssigneeCount]="assigneeTotalCount()"
          (paginationEmitter)="handleAssigneePaginationEmitter($event)"
          [totalPages]="
            assigneeTotalPages()
          "></lib-workflow-details-assignee-table-view>
      </lib-tab>
    </lib-tabs>
  </div>
}
